// extracted by mini-css-extract-plugin
export var dark = "select-module--dark--e1142";
export var light = "select-module--light--fd7b3";
export var pricing = "select-module--pricing--40a40";
export var selectArrow = "select-module--selectArrow--17799";
export var selectFieldGroup = "select-module--selectFieldGroup--e3cb4";